import { toast } from 'react-toastify'
import { parseToTimestamp } from '@/utils/datetime/formatDate'
import { waitForTransactionReceipt } from '@/utils/wagmi/waitForTransactionReceipt'
import { useWriteFactoryContract } from '@/hooks/survey-factory-contract/useWriteSurveyFactoryContract'
import { usePepperContractAddress } from '@/hooks/pepper-contract/usePepperContract'
import { useStaking2aAddress } from '@/hooks/staking2a-contract/useStaking2aContract'
import { logger } from '@/observability/logger'
import { parseEther } from 'viem'
import { readContract } from 'wagmi/actions'
import { wagmiConfig } from '@/config/wagmi-config'
import { abi } from '@/abi/SurveyFactory'
import { useSurveyFactoryContractAddress } from '@/hooks/survey-factory-contract/useSurveyFactoryContract'

export function useCreatePoll() {
	const writeFactoryContract = useWriteFactoryContract()
	const pepperAddress = usePepperContractAddress()
	const surveyFactoryAddress = useSurveyFactoryContractAddress()
	const stakingAddress = useStaking2aAddress()

	const createPoll = async ({
		question,
		answers,
		votingCap,
		startTime,
		endTime
	}: {
		question: string
		answers: string[]
		votingCap: number
		startTime: Date
		endTime: Date
	}) => {
		try {
			const start = parseToTimestamp(startTime)
			const end = parseToTimestamp(endTime)
			const delegate: `0x${string}` = '0x0000000000000000000000000000000000000000' // Dummy address

			const votingCapETH = parseEther(votingCap.toString())

			const surveyParams = {
				_questionId: question,
				_answerIds: answers,
				_startDate: BigInt(start),
				_endDate: BigInt(end),
				_votingCap: votingCapETH,
				token: pepperAddress,
				delegate,
				_whitelistEnabled: false,
				stakingAddress,
				metadataURL: ''
			}

			const hash = await writeFactoryContract({
				functionName: 'createSurvey',
				args: [surveyParams]
			})

			await waitForTransactionReceipt({ hash })

			const surveyCounter = await readContract(wagmiConfig, {
				address: surveyFactoryAddress,
				abi,
				functionName: 'surveyCounter'
			})

			const createdSurveyAddress = await readContract(wagmiConfig, {
				address: surveyFactoryAddress,
				abi,
				functionName: 'getSurvey',
				args: [surveyCounter - 1n]
			})

			toast.success('Survey Created Successfully')

			return createdSurveyAddress
		} catch (error) {
			logger.error(error, 'Error creating the survey')
			toast.error('An error occurred while creating the survey.')
		}
	}

	return { createPoll }
}
